import { SettleItem } from '../types';

export const getSettleAmount = (claims: SettleItem[]) => {
  const currency = claims[0].osShortfallAmount?.currency || undefined;
  const referenceNo = claims.map((s) => s.referenceNo).join('; ');
  const totalAmount = claims.reduce((acc, cur) => {
    const parsedFloat = Number.parseFloat(cur.shortfallFlag != 'Y' ? cur.osShortfallAmount?.amount || '' : '');
    const amount = Number.isNaN(parsedFloat) ? 0 : parsedFloat;

    return acc + amount;
  }, 0);

  return {
    currency,
    referenceNo,
    totalAmount,
  };
};
